import { configureUiModule, Problem, spinner } from '@app/ui';
import { Flippo } from '@webinex/flippo';
import axios from 'axios';
import { openid, rtkq, BaseModule, SETTINGS, CodedException } from '@app/base';
import { store } from './store';
import { ClippoHttp } from '@webinex/clippo';
import { configureChatSettings } from '@app/chat/settings';
import {
  CustomChatifyClient,
  useTableSettingsSave,
  useTableSettingsValue,
  VRowData,
  VRowMeta,
} from '@app/main/api';
import { RESOURCES } from 'virtual:i18next-resources';
import { notifyCoded } from './App';

const FLIPPO_CLIENT = new Flippo({
  axios: openid.intercept(axios.create({ baseURL: '/api/flippo' })),
});

const CLIPPO_CLIENT = new ClippoHttp<VRowMeta, VRowData>(
  openid.intercept(axios.create({ baseURL: '/api/clippo' })),
);

SETTINGS.APP_SETTINGS_CACHE_VERSION = '202502190342';
SETTINGS.DEFAULT_COUNTRY = 'United Kingdom';

export function configureApp() {
  BaseModule.init({
    resources: RESOURCES,
    platformCode: import.meta.env.VITE_PRODUCT_CODE,
  });

  configureUiModule({
    store,
    clippoClient: CLIPPO_CLIENT,
    flippoClient: FLIPPO_CLIENT,
    tableSettingsSource: {
      useValue: useTableSettingsValue,
      useSave: useTableSettingsSave,
    },
  });

  configureChatSettings({
    chatifyClient: new CustomChatifyClient({
      signalR: {
        hubUri: import.meta.env.VITE_CHATIFY_HUB_URL,
        accessTokenFactory: openid.token,
      },
      axios: openid.intercept(axios.create({ baseURL: '/api/chatify' })),
    }),
    flippo: FLIPPO_CLIENT,
  });

  rtkq.callbacks.on('error', (error) => {
    Problem.push(error);
    notifyCoded(CodedException.from(error));
  });
  rtkq.callbacks.on('spin', (show) => (show ? spinner.show() : spinner.hide()));
}
